import Well from './well'

export type { WellProps } from './well'

export default Well
